import { UserAction } from "@brookbush/types";

import { getCookie } from "cookies-next";
import posthog from "posthog-js";

import {
	type BecomeAMemberAction,
	type BecomeAMemberProperties,
	buildBecomeAMemberEvent,
} from "./becomeAMemberTracking";
import {
	getCurrentJoiningPriceOffer,
	type JoiningPriceOffer,
	joiningPriceEventProperties,
} from "./membership-joining-price";

/**
 * Captures a `become_a_member:*` PostHog event, attaching the CTA cookie when
 * the caller does not pass `cta_click`, plus the joining-price arm.
 *
 * @param {BecomeAMemberAction} action - Funnel step
 * @param {BecomeAMemberProperties} properties - Step-specific properties
 * @param {JoiningPriceOffer} [offer] - Arm to report; defaults to the one the plan cards stored, which is unset until they mount
 * @returns {void}
 */
const captureBecomeAMemberEvent = (
	action: BecomeAMemberAction,
	properties: BecomeAMemberProperties,
	offer: JoiningPriceOffer = getCurrentJoiningPriceOffer(),
): void => {
	const ctaClick =
		properties.cta_click ??
		getCookie(`${UserAction.BECOME_A_MEMBER}:cta-click`);

	const { event, properties: payload } = buildBecomeAMemberEvent(action, {
		...properties,
		cta_click: typeof ctaClick === "string" ? ctaClick : properties.cta_click,
		...joiningPriceEventProperties(offer),
	});

	posthog.capture(event, payload);
};

export default captureBecomeAMemberEvent;
